var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.564.556H2.991C1.341.556 0 1.823 0 3.384v19.232c0 1.561 1.34 2.829 2.991 2.829h9.573c1.651 0 2.992-1.268 2.992-2.829V3.384c0-1.561-1.34-2.828-2.992-2.828zM7.778 22.758c-.993 0-1.795-.758-1.795-1.697 0-.94.802-1.697 1.795-1.697.993 0 1.795.758 1.795 1.697 0 .939-.802 1.697-1.795 1.697z",
    fill: "url(#phone_svg__paint0_linear_4665_24869)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.564.556H2.991C1.341.556 0 1.823 0 3.384v19.232c0 1.561 1.34 2.829 2.991 2.829h9.573c1.651 0 2.992-1.268 2.992-2.829V3.384c0-1.561-1.34-2.828-2.992-2.828zM7.778 22.758c-.993 0-1.795-.758-1.795-1.697 0-.94.802-1.697 1.795-1.697.993 0 1.795.758 1.795 1.697 0 .939-.802 1.697-1.795 1.697z",
    fill: "url(#phone_svg__paint1_linear_4665_24869)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phone_svg__paint0_linear_4665_24869",
    x1: 15.866,
    y1: 0.784,
    x2: -6.744,
    y2: 14.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "phone_svg__paint1_linear_4665_24869",
    x1: 15.521,
    y1: 0.611,
    x2: -6.752,
    y2: 14.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#688FA5"
  })))));
}

export default __webpack_public_path__ + "./fonts/phone.0cf5510c4fcb89bbd690d0887693904e.svg";
export { SvgPhone as ReactComponent };